import defineService from './defineService';
import {fromApiAddressFormat, toApiAddressFormat} from "./mungeAddress";

const postUserAddress = defineService('post', 'api/v1/cart/custom/useraddresses/');
const putUserAddress = defineService('put', 'api/v1/cart/custom/useraddresses/:id/');
const deleteUserAddress = defineService('delete', 'api/v1/cart/custom/useraddresses/:id/');
const getUserAddresses = defineService('get', 'api/v1/cart/custom/useraddresses/', {mainKey: 'results'});

const postMemberAddress = defineService('post', 'api/v1/cart/custom/user/:uid/addresses/');
const putMemberAddress = defineService('put', 'api/v1/cart/custom/user/:uid/addresses/:id/');
const deleteMemberAddress = defineService('delete', 'api/v1/cart/custom/user/:uid/addresses/:id/');
const getMemberAddresses = defineService('get', 'api/v1/cart/custom/user/:uid/addresses/', {mainKey: 'results'});

const postTeamAddress = defineService('post', 'api/v1/cart/teamaddresses/');
const putTeamAddress = defineService('put', 'api/v1/cart/teamaddresses/:id/');
const deleteTeamAddress = defineService('delete', 'api/v1/cart/teamaddresses/:id/');
const getTeamAddresses = defineService('get', 'api/v1/cart/teamaddresses/', {mainKey: 'results'});

export const putVerifyAddress = defineService('put', 'api/v1/cart/address/:id/:type/verify/');
export const postVerifyAddressData = defineService('post', 'api/v1/cart/address/data/verify/');

export const getCountries = defineService('get', 'api/v1/cart/countries/');

function processError(e) {
  // Transform error into usable error message
  if (e.response && e.response.data) {
    let errors = e.response.data;
    if (errors.detail) {
      throw translateAddressError(errors.detail);
    } else {
      console.error(e);
      console.log(errors);

      // Typical errors structure will be {key: ['This field may not be blank.']}
      // Translate that to: Label is required
      let req = [], errs = [];
      for (let key in errors) {
        if (errors[key].length === 1 && errors[key][0].match(/not be blank/)) {
          req.push(key);
        } else {
          errs.push(key+': '+errors[key].join(', '));
        }
      }
      if (req.length == 1) {
        errs.push(req[0] + ' is required');
      } else if (req.length > 1) {
        errs.push(req.join(', ') + ' are required');
      }
      throw errs.join('. ');
    }
  }
  throw translateAddressError(e);
}

function translateAddressError(error) {
  console.log('-->', error);
  if (/^duplicate key value/.test(error)) {
    return 'That address is already in your list';
  }
  return error;
}

export function addUserAddress(address) {
  return postUserAddress(toApiAddressFormat(address)).catch(processError);
}

export function updateUserAddress(address) {
  return putUserAddress(address.id, toApiAddressFormat(address)).catch(processError);
}

export function removeUserAddress(address) {
  return deleteUserAddress(address.id).catch(processError);
}

export function userAddresses() {
  return getUserAddresses().then(fromApiAddressFormat);
}

export function addMemberAddress(uid, address) {
  return postMemberAddress(uid, toApiAddressFormat(address)).catch(processError);
}

export function updateMemberAddress(uid, address) {
  return putMemberAddress(uid, address.id, toApiAddressFormat(address)).catch(processError);
}

export function removeMemberAddress(uid, address) {
  return deleteMemberAddress(uid, address.id).catch(processError);
}

export function memberAddresses(uid) {
  return getMemberAddresses(uid).then(fromApiAddressFormat);
}

export function addTeamAddress(address) {
  return postTeamAddress(toApiAddressFormat(address)).catch(processError);
}

export function updateTeamAddress(address) {
  return putTeamAddress(address.id, toApiAddressFormat(address)).catch(processError);
}

export function removeTeamAddress(address) {
  return deleteTeamAddress(address.id).catch(processError);
}

export function teamAddresses() {
  return getTeamAddresses().then(fromApiAddressFormat);
}



// WEBPACK FOOTER //
// ./src/services/addresses.js